export function getDomainFromUrl(url: string) {
  const splitUrl = url.replace('http://', '').replace('https://', '').split('/')
  return splitUrl[0]
}
